import request from '@/router/axios';

export const getList = (current, size, params) => {
  return request({
    url: '/api/sino-biz/changeBulletin/list',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const getPage = (current, size, params) => {
  return request({
    url: '/api/sino-biz/changeBulletin/page',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const getDetail = (id) => {
  return request({
    url: '/api/sino-biz/changeBulletin/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/api/sino-biz/changeBulletin/remove',
    method: 'post',
    params: {
      ids,
    }
  })
}

export const add = (row) => {
  return request({
    url: '/api/sino-biz/changeBulletin/submit',
    method: 'post',
    data: row
  })
}

export const update = (row) => {
  return request({
    url: '/api/sino-biz/changeBulletin/submit',
    method: 'post',
    data: row
  })
}

export const submitChangeBulletin = (row) => {
  return request({
    url: '/api/sino-biz/changeBulletin/submitChangeBulletin',
    method: 'post',
    data: row
  })
}

export const getVerifyList = (current, size, params) => {
  return request({
    url: '/api/sino-biz/changeBulletin/verifyPage',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const verifyInfo = (row) => {
  return request({
    url: '/api/sino-biz/changeBulletin/verifyInfo',
    method: 'post',
    data: row
  })
}
